import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../../base/services/base.service";
import {AuthService} from "../../../../../common/modules/auth/services/auth.service";
import {NotifierService} from "../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {IParams} from "../../../../../../base/endpoints/iparams";
import {DashEndpoint} from "../../../../dash.endpoint";
import {IPage, ResponseData} from "../../../../../../base/models/pagination.model";
import {IBlogMenu, IBlogMenuDetail, IBlogMenuReq} from "../models/blogmenu.model";
import {IAuth} from "../../../../../common/modules/auth/models/auth.model";
@Injectable({
  providedIn: 'root'
})
export class BlogMenuService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBusService: EventBusService
  ) {
    super(authService, notifier)
  }

  search(key: string, endpoint: string, params: IParams) {
    let url = DashEndpoint.BLOGMENUS.SEARCH(endpoint, params)
    this.http.get<ResponseData<IPage<IBlogMenu>>>(url)
      .subscribe((data: ResponseData<IPage<IBlogMenu>>) => {
        this.eventBusService.publish(key, data.body)
      }, error => {
        this.handleError(error, (auth: IAuth) => {
          this.search(key, endpoint, params)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  fetchSingle(key: string, endpoint: string, id: number) {
    this.http.get<ResponseData<IBlogMenu>>(DashEndpoint.BLOGMENUS.GET(endpoint, id))
      .subscribe((data: ResponseData<IBlogMenu>) => {
        this.eventBusService.publish(key, data.body)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchSingle(key, endpoint, id)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  upsert(key: string, endpoint: string, blogMenuReq: IBlogMenuReq, exId: number | null) {
    let url = exId == null ? DashEndpoint.BLOGMENUS.CREATE(endpoint)
      : DashEndpoint.BLOGMENUS.UPDATE(endpoint, exId)

    let observable = exId == null ?
      this.http.post<ResponseData<IBlogMenuDetail>>(url, blogMenuReq)
      : this.http.patch<ResponseData<IBlogMenuDetail>>(url, blogMenuReq)

    observable.subscribe(res => {
      this.eventBusService.publish(key, res.body)
    }, (err: HttpErrorResponse) => {
      this.handleError(err, (auth: IAuth) => {
        this.upsert(key, endpoint, blogMenuReq, exId)
      }, (err: HttpErrorResponse) => {
        this.eventBusService.publish(this.getErrorKey(key), err)
      })
    })
  }

}
